module.exports = __webpack_public_path__ + "img/FR16106.3c62c2ca.svg";